<script lang="ts">
  import { formatDollars } from "$lib/format";

  export let usage: number;
  export let credits: number;
</script>

<div>
  {#if credits}
    {#if usage <= credits}
      {@const barPercentage = (100 * usage) / credits}
      <div class="flex text-zinc-400">
        <span style:width="{barPercentage}%" class="row-text">
          {formatDollars(usage)}
        </span>
        <span style:width="{100 - barPercentage}%" class="row-text ml-1">
          {formatDollars(credits)}
        </span>
      </div>
      <div class="row-bar-bg">
        <div class="row-bar-zinc" style:width="{barPercentage}%"></div>
      </div>
    {:else}
      {@const barPercentage = (75 * credits) / usage}
      <div class="flex text-zinc-400">
        <span style:width="{barPercentage}%" class="row-text">
          {formatDollars(credits)}
        </span>
        <span style:width="{75 - barPercentage}%" class="row-text ml-1">
          {formatDollars(usage)}
        </span>
        <span style:width="25%" class="row-text ml-1"></span>
      </div>
      <div class="row-bar-bg">
        <div class="row-bar-zinc" style:width="{barPercentage}%"></div>
        <div class="row-bar-lime" style:width="{75 - barPercentage}%"></div>
      </div>
    {/if}
    <p class="mt-2 text-zinc-400 text-xs">
      {Math.min(100, (100 * usage) / credits).toFixed(0)}% of included credits
      used
    </p>
  {/if}
  {#if usage > credits || credits == 0}
    <p class="mt-0.5">
      {formatDollars(usage - credits)} in additional usage
    </p>
  {/if}
</div>

<style lang="postcss">
  .row-text {
    @apply inline-block text-end;
    min-width: min-content;
  }
  .row-bar-zinc {
    @apply z-10 h-4 bg-zinc-400;
  }
  .row-bar-lime {
    @apply z-10 h-4 bg-primary;
  }
  .row-bar-bg {
    @apply flex w-full h-4 bg-white/10 rounded-md overflow-hidden my-2;
  }
</style>
